module.exports = __webpack_public_path__ + "static/media/start_hover.9361029a.svg";